export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu.vue?vue&type=template&id=89724e30"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/menu.vue?vue&type=template&id=89724e30
// module id = Efdj
// module chunks = 0